import React, { Component } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
//import {} from './RelativeRouting';
import NavigationBar from './components/NavigationBar';
import Home from './pages/Home';
import { Manual } from './pages/Manual';
import Registration  from './pages/Registration';
import Admin from './pages/Admin';
import Login from './pages/Login';
import EditItem from './pages/EditItem';
import ItemPage from './pages/ItemPage';
import { NoMatch } from './pages/NoMatch';
import ItemRegistration from './components/ItemRegistration';
import Footer from './components/Footer';
import Profile from './pages/Profile';
import PasswordReminder from './pages/PasswordReminder';
import {config } from './config';
import SuccessfulRegistration from './pages/SuccessfulRegistration';

export default class KwzidaRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {loggedIn : localStorage.getItem("userData")  }
  }

  //const [loggedIn, setLoggedIn] = useState();
  logout = () => {
    console.log("Logout");
    localStorage.removeItem('userData');
    this.setLoggedIn(false);
  }

  login = () => {
    this.setLoggedIn(localStorage.getItem("userData"));
  }

  setLoggedIn = (val) => {
    //console.log("set logged in:", val);
    this.setState({loggedIn: val});
  }
    
  render() { 
    return ( 
      <React.Fragment>
        <Router basename={config.BASE_PATH}>
          <NavigationBar loggedIn={this.state.loggedIn} clickLogout={this.logout}/>
          <div className="kwizda-page-container">
          <Switch>
            <Route exact path={'/'}>
              <Home loggedIn={this.state.loggedIn} />
            </Route> 
            <Route exact path={'/fooldal'}>
              <Home loggedIn={this.state.loggedIn} />
            </Route> 
            <Route path="/szabalyzat">
              <Manual/>
            </Route>
            <Route path="/bejelentkezes" >
              <Login clickLogin={this.login} />
            </Route>
            <Route path="/regisztracio" render={
              (routeProps) => <Registration {...routeProps} setLogin={this.login}/>} />
            <Route path="/profil" component={Profile} />
            <Route path="/admin">
              <Admin loggedIn={this.state.loggedIn}></Admin>
            </Route>
            <Route path="/termekregisztracio" component={ItemRegistration} />
            <Route path="/sikeresregisztracio" component={SuccessfulRegistration} />
            <Route path="/termekszerkesztes" component={EditItem} />
            <Route path="/emlekezteto" component={PasswordReminder} />
            <Route path="/termek" component={ItemPage} />
            <Route component={NoMatch} />
          </Switch> 
          </div>
          <Footer></Footer>
        </Router>
        
        
      </React.Fragment>
    );
  }
}
 